export default {  //將整理好的圖片路徑和方法給組件使用
    roomsImg: [
        {
            id: '3Elqe8kfMxdZv5xFLV4OUeN6jhmxIvQSTyj4eTgIowfIRvF4rerA2Nuegzc2Rgwu',
            primaryImg: require('../../public/room1/primary.jpg'),
            secondImg: require('../../public/room1/second.jpg'),
            thirdImg: require('../../public/room1/third.jpg'),
        },
        {
            id: 'g0mYhN6ignMz4VYW7eiWsXZN8DHolHzH8LuVmM6hq5h6BrrqrLMw4aJgHv7LZ3RQ',
            primaryImg: require('../../public/room2/primary.jpg'),
            secondImg: require('../../public/room2/second.jpg'),
            thirdImg: require('../../public/room2/third.jpg'),
        },
        {
            id: 'RA8NhExaXXZB7EODVALSDvFFQzj1JP0a4C1pwZ1acPaieRBwiWoCb0FE0KUbXaxg',
            primaryImg: require('../../public/room3/primary.jpg'),
            secondImg: require('../../public/room3/second.jpg'),
            thirdImg: require('../../public/room3/third.jpg'),
        },
        {
            id: 'kICyWhZ5XsfI4n1d4gBOsDjIyIxNozwgmxYKyZpzi5pjLcU2Nl4RhiGrn6zaPuTJ',
            primaryImg: require('../../public/room4/primary.jpg'),
            secondImg: require('../../public/room4/second.jpg'),
            thirdImg: require('../../public/room4/third.jpg'),
        },
        {
            id: 'VCxbQq1vLeUtxW781k9Dlq3mHBRNl5YP19Lhq8k5TbIr2BeH58gRpnNKGoEgkysz',
            primaryImg: require('../../public/room5/primary.jpg'),
            secondImg: require('../../public/room5/second.jpg'),
            thirdImg: require('../../public/room5/third.jpg'),
        },
        {
            id: 'YovqNpFDaal598jbpd1A14gXwDE6gekTqJgxOAGcq78B8YnP7claymQVFy2GTwgb',
            primaryImg: require('../../public/room6/primary.jpg'),
            secondImg: require('../../public/room6/second.jpg'),
            thirdImg: require('../../public/room6/third.jpg'),
        },
    ],
    currentRoomImg(id) { //房間頁面圖片
        let list = []
        this.roomsImg.forEach(e => {
            if(e.id===id){
                list.push({src:e.primaryImg}) //因應外掛組件 lightbox 需要的物件格式
                list.push({src:e.secondImg})
                list.push({src:e.thirdImg})
            }
        })
        return list
    },
    indexRoomsImg() { //主頁大圖
        let list = []
        this.roomsImg.forEach(e => {
            list.push(e.primaryImg)
        })
        return list
    },
    detailRoomsImg() { //主頁資訊卡圖
        let list = []
        this.roomsImg.forEach(e => {
            list.push(e.secondImg)
        })
        return list
    }
}